import React from 'react';

import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

import { MoreIcon } from '../../icons';

import { getActionIconStyles } from './MoreButtonCDS.styles';

const MoreButtonCDS = ({
  onClick,
  disabled = false,
  size = 'medium',
  isSelected = false,
  isHighlighted = false,
  customStyles,
  ...props
}) => (
  <IconButton
    aria-label="More actions"
    aria-selected={isSelected}
    className="more-button"
    disabled={disabled}
    size={size}
    sx={getActionIconStyles({ isHighlighted, customStyles })}
    onClick={onClick}
    {...props}
  >
    <MoreIcon />
  </IconButton>
);

MoreButtonCDS.propTypes = {
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  size: PropTypes.string,
  customStyles: PropTypes.object,
  onClick: PropTypes.func,
};

export default MoreButtonCDS;
